export default __webpack_public_path__ + "static/media/icon-mute.2725462f.svg";